"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogHeaderImage = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeaderImage"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _sources = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/sources");

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var TRIAL = _sources.sourceKeys.TRIAL;
var LANG_ROUTE = 'upgrades.activationModal';

var ActivationSuccessModal = function ActivationSuccessModal(_ref) {
  var type = _ref.type,
      onSuccess = _ref.onSuccess,
      header = _ref.header,
      subText = _ref.subText,
      ctaText = _ref.ctaText,
      showIllustration = _ref.showIllustration;
  var isTrialModal = type === TRIAL;
  return _react.default.createElement(_UIModal.default, {
    centered: true,
    size: "auto",
    use: "success",
    width: 600
  }, showIllustration && _react.default.createElement(_UIDialogHeaderImage.default, {
    offsetBottom: -30,
    offsetTop: 40
  }, _react.default.createElement(_UIIllustration.default, {
    name: "success",
    width: 118
  })), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_H.default, null, header || _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + "." + (isTrialModal ? 'trialTitle' : 'productTitle')
  }))), _react.default.createElement(_UIDialogBody.default, null, subText && _react.default.createElement("p", null, subText)), _react.default.createElement(_UIDialogFooter.default, {
    align: "center"
  }, _react.default.createElement(_UIButton.default, {
    use: "primary",
    onClick: onSuccess
  }, ctaText || _react.default.createElement(_FormattedMessage.default, {
    message: LANG_ROUTE + ".getStarted"
  }))));
};

ActivationSuccessModal.defaultProps = {
  showIllustration: true
};
ActivationSuccessModal.propTypes = {
  type: _propTypes.default.string.isRequired,
  onSuccess: _propTypes.default.func,
  header: _propTypes.default.node,
  subText: _propTypes.default.node,
  ctaText: _propTypes.default.node,
  showIllustration: _propTypes.default.bool
};
var _default = ActivationSuccessModal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/ActivationSuccessModal.js
// module id = 336
// module chunks = 5 6